<div fxLayoutAlign="center center" style="margin-top: 1em;">
  <div fxFlex="80" fxLayoutAlign="center center" fxLayoutGap="5%">
    <img src="/assets/i/tenant.jpg" fxFlex="50">
    <div fxFlex="50">
      <h2>Tenant Law</h2>
      <p>Law Offices of Serros & Bauman both defends tenants in evictions and helps them sue landlords who have violated state and local laws. Now more than ever tenants in the Bay Area are facing aggressive landlords who may have little regard for their rights. We are here to help you understand your rights and use them to achieve a fair outcome.</p>
    </div>
  </div>
</div>
